import { render, staticRenderFns } from "./mainTop.vue?vue&type=template&id=66769f61"
import script from "./mainTop.vue?vue&type=script&lang=js"
export * from "./mainTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports